(function () {

  /**
   * @author - Allen Kim
   * @name ute-msg-for
   */
  'use strict';

  angular.module('ute.ui')

    .directive('uteMsgFor', ['$compile', function ($compile) {
      return {
        link: function (scope, element, attrs) {
          var el = element[0];
          var attrValue = attrs.uteMsgFor;
          /**
           * TODO buggy, need to get the parent form element
           if (el.form.name && !attrValue.match(/\./)) {
            attrValue = el.form.name + '.' + attrValue;
          }
           */
          var ngShowValue = attrValue + '.$touched && ' + attrValue + '.$invalid';
          el.setAttribute('ng-show', ngShowValue);
          el.removeAttribute('ute-msg-for'); // IMPORTANT to prevent loop
          el.setAttribute('ute-msg-for-removed', attrValue);
          $compile(el)(scope);
        }
      };
    }]);

})();
